export default __webpack_public_path__ + "assets/images/image_ethercards.d53d34c0.png";